import { LoadFilesTypes } from './actionTypes';

const INIT_STATE = {
    data: [],
    message: '',
    success: '',
    isLoading: false,
};

const loadFiles = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case LoadFilesTypes.UPDATE_FILE:
            state = {
                ...state,
                isLoading: true,
                message: '',
                data: []
            };
            break;
        case LoadFilesTypes.UPDATE_FILE_SUCCESS:
            return {
                ...state,/* change */
                data: action?.payload?.data?.LoadFileCSV?.data,
                success: action?.payload?.data?.LoadFileCSV?.success,
                message: action?.payload?.data?.LoadFileCSV?.message,
                isLoading: false,
            };
        case LoadFilesTypes.UPDATE_FILE_FAIL:
            return {
                ...state,
                data: [],
                success: action?.payload?.data?.LoadFileCSV?.success,
                message: action?.payload?.message,
                isLoading: false,
            };

        default:
            break;
    }
    return state;
};

export default loadFiles;
